const initialState = {
    projects: [],
    project: {}
}
export default (state = initialState, action) => {
    switch (action.type) {
        case 'LOAD_PROJECTS':
            return {
                ...state,
                projects: action.projects
            }
        case 'VIEW_PROJECT':
            return {
                ...state,
                project: action.project
            }
        case 'CLAP_PROJECT':
            let project = Object.assign({}, state.project)
            project.claps++
            console.log(project)
            return {
                ...state,
                project: project
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/projects.js